import { createSelector } from '@reduxjs/toolkit';

import { EstimateState } from './estimate.types';

import { Estimate } from '~/core/models';
import { RootState } from '~/redux/store';

export const selectCurrentEstimate = ({ estimate }: RootState): Estimate =>
  estimate.currentEstimate;

export const selectLoadEstimateKeys = ({
  estimate,
}: RootState): EstimateState['loadEstimateKeys'] => estimate.loadEstimateKeys;

export const selectIsSavingEstimate = ({
  estimate,
}: RootState): EstimateState['isSavingEstimate'] => estimate.isSavingEstimate;

export const selectStatusUpdateInterval = ({
  estimate,
}: RootState): EstimateState['statusUpdateInterval'] =>
  estimate.statusUpdateInterval;

export const selectEeStatusList = ({
  estimate,
}: RootState): EstimateState['eeStatusList'] => estimate.eeStatusList;

export const selectCompletedEstimates = ({
  estimate,
}: RootState): EstimateState['completedEstimates'] =>
  estimate.completedEstimates;

export const selectLatestEstimate = createSelector(
  [({ estimate }: RootState) => estimate],
  (estimate) =>
    estimate.completedEstimates[estimate.completedEstimates.length - 1]
);

export const selectIsCompletedEstimate = ({
  estimate,
}: RootState): EstimateState['isCompletedEstimate'] =>
  estimate.isCompletedEstimate;

export const selectShowListOfEstimates = ({
  estimate,
}: RootState): EstimateState['showListOfEstimates'] =>
  estimate.showListOfEstimates;

export const selectCurrentEstimateCode = ({
  estimate,
}: RootState): EstimateState['currentEstimateCode'] =>
  estimate.currentEstimateCode;

export const selectLoadEstimateCode = ({
  estimate,
}: RootState): EstimateState['loadEstimateCode'] => estimate.loadEstimateCode;

export const selectIsNewEstimate = ({
  estimate,
}: RootState): EstimateState['isNewEstimate'] => estimate.isNewEstimate;

export const selectIsWatchingEstimate = ({
  estimate,
}: RootState): EstimateState['isWatchingEstimate'] =>
  estimate.isWatchingEstimate;

export const selectEstimateHasBeenSaved = ({
  estimate,
}: RootState): EstimateState['estimateHasBeenSaved'] =>
  estimate.estimateHasBeenSaved;

export const selectValidSmallTicketNumber = ({
  estimate,
}: RootState): EstimateState['validSmallTicketNumber'] =>
  estimate.validSmallTicketNumber;

export const selectIgnoreFetchedEstimate = ({
  estimate,
}: RootState): EstimateState['ignoreFetchedEstimate'] =>
  estimate.ignoreFetchedEstimate;

export const selectPrevEstimateStatus = ({
  estimate,
}: RootState): EstimateState['prevEstimateStatus'] =>
  estimate.prevEstimateStatus;

export const selectWasEstimateApplianceMoved = ({
  estimate,
}: RootState): EstimateState['wasEstimateApplianceMoved'] =>
  estimate.wasEstimateApplianceMoved;

export const selectDiscountOverride = ({
  estimate,
}: RootState): EstimateState['discountOverride'] => estimate.discountOverride;
